import ContactsOutlined from "@mui/icons-material/ContactsOutlined";
import GroupsOutlined from "@mui/icons-material/GroupsOutlined";
import PersonOutlineOutlined from "@mui/icons-material/PersonOutlineOutlined";
import {lazy} from "react";
import type {Page, PageGroup} from "router/types";

const AddressGroupPage = lazy(
  () => import("pages/address-contacts/address-group/AddressGroupPage"),
);
const AddressGroupViewPage = lazy(
  () =>
    import(
      "pages/address-contacts/address-group/[id]/view/AddressGroupViewPage"
    ),
);
const ContactListPage = lazy(
  () => import("pages/address-contacts/contact-list/ContactListPage"),
);

const addressContactsRoutes: Array<Page | PageGroup> = [
  {
    segment: "address-contacts",
    title: "Address Contacts",
    Icon: ContactsOutlined,
    children: [
      {
        segment: "address-groups",
        title: "Address Groups",
        Icon: GroupsOutlined,
        Component: AddressGroupPage,
      },
      {
        segment: "address-groups/:id/view",
        title: "Address Group View",
        Icon: GroupsOutlined,
        Component: AddressGroupViewPage,
        hideFromNav: true,
      },
      {
        segment: "contact-list",
        title: "Address Contacts",
        Icon: PersonOutlineOutlined,
        Component: ContactListPage,
      },
    ],
  },
];

export default addressContactsRoutes;
